import React, { Component } from 'react';
import Translator from '../../core/i18n';
import { Log, Level, Logger, Display } from 'ng2-logger';
import { IAppState, IAction } from '../../models/action/core';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import * as Actions from '../../store/actions/userHome';
import * as ProfileActions from '../../store/actions/profile';
import Moment from 'moment';
import { UserType } from '../../models/pages/login.d';
import Loading from '../loading/loading';
import { IUserHomeMyCoursesProps } from '../../models/components/user-home_my_courses';
import { OverlayTrigger, Popover, Badge } from 'react-bootstrap';
import { Link, withRouter } from 'react-router-dom';
import { Common } from '../../core/common';
import * as RequestAction from '../../store/actions/request';
import { SecureImage } from '../core/secureImage';
import ProgressCircle from '../progress-circle/progress-circle';
import ContentLoader from 'react-content-loader';
import { ActivityType, ActivityTypeEnums } from '../../models/enums/ActivityType';
import moment from 'moment';
import ShowAllButton from '../show-all-button/main';
import Tooltip from '../tooltip/main';
import Truncate from 'react-truncate';
import Truncater from '../truncater/main';
import Avatar from '../avatars/main';
import NotFound from '../not-found/not-found';

const _logger = Log.create('User Calendar');
const T = Translator.create();
let _common: Common;

class UserMyCourses extends React.Component<IUserHomeMyCoursesProps, any> {
    moreLesson: any;
    constructor(props: any) {
        super(props);
        _common = new Common();

        this.state = {
            filters: {
                termId: 0,
                programId: 0,
                status: 1,
                sourceCourseId: '',
                courseId: ''
            },
            showMobile: false,
            showMoreTeacher: false,
            showMoreProgram: false,
            isTeacher:
                this.props.userType && (this.props.userType === UserType.Teacher || this.props.userType === UserType.ProgramAdmin)
                    ? true
                    : false,
            moreTeachersCourseId: '',
            moreLesson: false
        };
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }

    componentWillMount() {
        this.handleResize();
    }
    public handleResize() {
        if (window.innerWidth > 748) {
            this.setState({ showMobile: false });
        } else {
            this.setState({ showMobile: true });
        }
    }

    public componentDidMount = () => {
        window.addEventListener('resize', this.handleResize);
        const isTeacher =
            this.props.userType && (this.props.userType === UserType.Teacher || this.props.userType === UserType.ProgramAdmin)
                ? true
                : false;
        this.props.dispatch(Actions.getUserHomeMyCourses(isTeacher, 'getUserHomeMyCourses', 'get', '', this.state.filters));
        this.props.dispatch(ProfileActions.getPreferencesAction());
    };
    public onErrorCourseLogo = (event: any) => {
        if (event && event.target.src !== _common.GetDefaultImages('_course')) {
            event.target.src = _common.GetDefaultImages('_course');
        }
    };
    public navigateUrl(classId?: string | null, activityId?: string | null) {
        const url = window.appSettings.DEFAULT_URL + '/u/course?classId=' + classId + '&activityId=' + activityId + '&type=1';
        this.props.history.push(url);
    }
    public getUpcomingActivities(classId: string, courseId: string) {
        this.props.dispatch(Actions.clearUserHomeUpcomingActivities());
        this.props.dispatch(Actions.getUserHomeUpcomingActivities(classId, courseId, 0, 5, 24, 'getUpcomingActivities', 'get'));
    }
    public clearUpcomingActivities() {
        this.props.dispatch(Actions.clearUserHomeUpcomingActivities());
    }

    viewMarginTopValue = () => {
        let returnValue = '10px';
        if (this.state.showMobile) {
            returnValue = '20px';
        }
        return returnValue;
    };

    isWithinDate = (date: any) => {
        let nowDate = moment().format('yyyy-MM-DDTHH:mm:ss');
        let isWithinDateRange = false;
        if (date) {
            isWithinDateRange = date.toString() >= nowDate;
        }
        return isWithinDateRange;
    };

    activeCourses = () => {
        let activeCourses = null;
        if (this.props.userHomeMyCourses && this.props.userHomeMyCourses.length > 0) {
            activeCourses = this.props.userHomeMyCourses.filter(f => {
                const isActive = f.activeStatus === 1;
                let isWithinDateRange = false;
                let dateCondition = false;
                if (f.courseId && this.state.isTeacher) {
                    dateCondition = f.termId === null || f.endDate === null;

                    isWithinDateRange = this.isWithinDate(f.endDate);
                } else {
                    dateCondition = f.termId === null || f.courseEndDate === null;

                    isWithinDateRange = this.isWithinDate(f.courseEndDate);
                }
                const isCourseActive = isActive && (dateCondition || isWithinDateRange);
                return isCourseActive;
            });
        }
        return activeCourses;
    };

    renderMyCoursesHeader = (filteredCourses: any) => {
        let totalCourseCount = 0;

        if (filteredCourses) {
            totalCourseCount = filteredCourses.length;
        }
        return (
            filteredCourses &&
            filteredCourses.length > 0 && (
                <div
                    className="d-flex justify-content-between student-course-header"
                    style={{ padding: '2px 0px', marginBottom: '-7px', marginTop: this.viewMarginTopValue() }}
                >
                    <div>
                        <span className="lms-header-medium" tabIndex={0}>
                            {T.t('r_menu_my_courses')}
                        </span>
                    </div>
                    <div className="align-self-center">
                        <span style={{ fontSize: '12px', padding: '3px' }} tabIndex={0}>
                            {T.t('r_total_course')}
                        </span>
                        <Badge
                            pill={true}
                            variant="light"
                            style={{ backgroundColor: '#d9dadc', fontWeight: 600, fontSize: '10px', marginInlineEnd: '10px' }}
                            tabIndex={0}
                        >
                            {totalCourseCount}
                        </Badge>
                        <ShowAllButton redirectUrl="/u/mycourse" />
                    </div>
                </div>
            )
        );
    };

    renderMyCoursesLoading = () => {
        return (
            <Loading spinnerId={'getUserHomeMyCourses'}>
                <div className="grid-3 gap-2">
                    {[...Array(9)].map((_, index) => (
                        <ContentLoader
                            key={index}
                            speed={2}
                            backgroundColor="rgb(243,243,243)"
                            foregroundColor="rgb(214,214,214)"
                            viewBox="0 0 300 180"
                        >
                            {/* Üst Etiket */}
                            <rect x="10" y="10" rx="4" ry="4" width="80" height="15" />

                            {/* Başlık */}
                            <rect x="10" y="40" rx="4" ry="4" width="90%" height="20" />

                            {/* Alt Satır */}
                            <rect x="10" y="70" rx="4" ry="4" width="60%" height="15" />

                            {/* Alt İkonlar */}
                            <circle cx="30" cy="140" r="12" />
                            <circle cx="70" cy="140" r="12" />
                            <circle cx="110" cy="140" r="12" />
                            <circle cx="150" cy="140" r="12" />
                        </ContentLoader>
                    ))}
                </div>
            </Loading>
        );
    };

    renderProgramNames = (programName: string | null | undefined) => {
        if (!programName) return '';

        return programName && programName.length < 60 ? (
            <>{programName}</>
        ) : (
            <div className="mobile-mt1">
                <div>
                    <span className="mt-1">{programName}</span>
                </div>
            </div>
        );
    };

    renderCourseTeachers = (teachers: string, courseId: any) => {
        let shortenedTeacherName;
        if (teachers && teachers.length > 75) {
            if (this.state.moreTeachersCourseId == courseId) {
                shortenedTeacherName = (
                    <>
                        {' '}
                        {teachers}
                        {this.showMoreButton(T.t('r_gen_show_less'), 'float_auto_dir ml-3', '#ff0000', 'moreTeachersCourseId', '')}{' '}
                    </>
                );
            } else {
                shortenedTeacherName = (
                    <>
                        {' '}
                        {`${teachers.substring(0, 75)}...`}{' '}
                        {this.showMoreButton(
                            T.t('r_gen_show_more'),
                            'float_auto_dir show_more_text',
                            '#39B27B',
                            'moreTeachersCourseId',
                            courseId
                        )}{' '}
                    </>
                );
            }
        } else {
            shortenedTeacherName = teachers;
        }
        return teachers && teachers.length > 75 ? (
            <p className="hiddenText" tabIndex={0}>
                {teachers && teachers.length > 75 ? shortenedTeacherName : teachers}
            </p>
        ) : null;
    };

    showMoreButton = (text: string, buttonClass: string, _color: string, stateName: any, courseId: any) => {
        return (
            <button
                onClick={() =>
                    this.setState((prevState: any) => ({
                        [stateName]: stateName == 'moreTeachersCourseId' ? courseId : !prevState[stateName]
                    }))
                }
                className={buttonClass}
                style={{ fontSize: '12px', margin: '0px 0px 0px 10px', color: _color, background: 'none', border: 'none' }}
            >
                {text}
            </button>
        );
    };
    getColorFromName = (name: string) => {
        let hash = 0;
        for (let i = 0; i < name.length; i++) {
            hash = name.charCodeAt(i) + ((hash << 5) - hash);
        }

        let color =
            '#' +
            ((hash >> 24) & 0xff).toString(16).padStart(2, '0') +
            ((hash >> 16) & 0xff).toString(16).padStart(2, '0') +
            ((hash >> 8) & 0xff).toString(16).padStart(2, '0');

        // Parlaklık kontrolü (0 ile 255 arasında bir değer döner)
        const brightness = this.getBrightness(color);

        // Beyaza yakın renkler için kontrol
        if (brightness > 200) {
            // 200 üzeri parlaklık çok açık renklerdir
            color = '#' + ((hash & 0x7f7f7f) | 0x404040).toString(16).padStart(6, '0'); // Daha koyu bir renk üret
        }

        return color.slice(0, 7);
    };

    // Renk parlaklığını hesaplayan fonksiyon
    getBrightness = (color: string) => {
        const r = parseInt(color.slice(1, 3), 16);
        const g = parseInt(color.slice(3, 5), 16);
        const b = parseInt(color.slice(5, 7), 16);
        return r * 0.299 + g * 0.587 + b * 0.114;
    };

    generateRandomGradient(): string {
        // Belirtilen renk çiftleri
        const gradientPairs = [
            ['#614385'],
            ['#516395'],
            ['#02AABD'],
            ['#00CDAC'],
            ['#11998E'],
            ['#0cb44b'],
            ['#764BA2'],
            ['#667EEA'],
            ['#06c9bb'],
            ['#2a96ac'],
            ['#f56565'],
            ['#3d87de'],
            ['#5D54A4'],
            ['#9A75CD'],
            ['#5B86E5'],
            ['#ff6f61'],
            ['#970caf'],
            ['#6A11CB'],
            ['#2575FC'],
            ['#4CA1AF'],
            ['#1FA2FF'],
            ['#667EEA'],
            ['#764BA2'],
            ['#2A5298'],
            ['#1E3C72']
        ];

        // Rastgele bir renk çifti seç
        const [color1] = gradientPairs[Math.floor(Math.random() * gradientPairs.length)];
        const color1WithAlpha = this.hexToRgba(color1, 0.75);
        return `radial-gradient(circle,${color1WithAlpha}, ${color1})`;
    }
    hexToRgba(hex: string, alpha: number): string {
        const bigint = parseInt(hex.slice(1), 16);
        const r = (bigint >> 16) & 255;
        const g = (bigint >> 8) & 255;
        const b = bigint & 255;

        return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    }

    renderProgramNameContent = (item: any) => {
        const background = this.generateRandomGradient();
        return (
            <>
                <div
                    className="position-relative"
                    style={{ backgroundColor: 'rgb(255 255 255)', height: '96px', padding: '8px', margin: '-8px' }}
                >
                    <div className=" align-items-start d-flex mb-2" style={{ whiteSpace: 'nowrap' }}>
                        {/* <SecureImage imageUrl={item.logoUrl!} style={null} class={'course-icon'} imgType={'smallCourse'} /> */}
                        <div className="list-content d-inline-block ">
                            <div
                                className="alms-h6 d-flex flex-column gap-1 align-items-start"
                                style={{ whiteSpace: 'pre-line', marginInlineStart: '8px' }}
                            >
                                <div>
                                    {item.termName ? (
                                        item.termName.length > 32 ? (
                                            <Tooltip data={item.termName} delay={100} position="top">
                                                <Truncater text={item.termName} length={32} className="term_tag" as="span" />
                                            </Tooltip>
                                        ) : (
                                            <span className="term_tag">{item.termName}</span> // 40 karakterden küçükse burası çalışır
                                        )
                                    ) : (
                                        <span className="term_tag">{T.t('r_gen_non_term_courses')}</span> // `item.termName` yoksa burası çalışır
                                    )}
                                </div>

                                {/* kurs adı */}
                                {item.name.length > 48 ? (
                                    <div className="mt-1" style={{ maxWidth: 'calc(100% - 28px)' }}>
                                        <Tooltip widthValue="100%" data={item.name} delay={300} position="top">
                                            <Truncater text={item.name} length={48} className="course-name w-100" as="span"></Truncater>
                                        </Tooltip>
                                    </div>
                                ) : (
                                    <span className="course-name">{item.name}</span>
                                )}
                            </div>
                        </div>
                    </div>
                    <div
                        style={{
                            position: 'absolute',
                            top: '8px',
                            right: document.body.getAttribute('dir') == 'rtl' ? 'unset' : '0px',
                            left: document.body.getAttribute('dir') == 'rtl' ? '0px' : 'unset'
                        }}
                    >
                        {this.renderProgressCircle(item.progress)}
                    </div>
                </div>
            </>
        );
    };

    renderNewActivityIcon = (item: any) => {
        return (
            <div className="list-icons ">
                <Tooltip
                    data={
                        item.newActivityCount && item.newActivityCount > 0
                            ? T.t('r_gen_student_newActivity_info').replace('{0}', item.newActivityCount)
                            : ''
                    }
                    position="top"
                >
                    <i className={item.newActivityCount && item.newActivityCount > 0 ? ' notify-dot' : 'opacity-3'} tabIndex={0}>
                        <img src={_common.GetDefaultIcons('new')} alt="newActivityCount" />
                    </i>{' '}
                </Tooltip>
            </div>
        );
    };

    getUpcomingActivitiesIcon = (item: any) => {
        return (
            <div className="list-icons ">
                <Tooltip
                    data={
                        this.props.userUpcomingActivities && this.props.userUpcomingActivities.length > 0
                            ? this.props.userUpcomingActivities && this.props.userUpcomingActivities.length > 0
                                ? // tslint:disable-next-line:no-shadowed-variable
                                  this.props.userUpcomingActivities.map((item, index) => (
                                      <span key={index}>
                                          {T.t('r_activity_type_' + ActivityTypeEnums[item.activityType!])} {T.t('r_delivery_date')}{' '}
                                          {Moment(item.deadline).fromNow()}
                                          <br />
                                      </span>
                                  ))
                                : ''
                            : ''
                    }
                    position="top"
                >
                    <i
                        tabIndex={0}
                        aria-hidden="true"
                        onMouseOver={this.getUpcomingActivities.bind(
                            this,
                            item.classId ? item.classId : '0',
                            item.courseId ? item.courseId : '0'
                        )}
                        onFocus={this.getUpcomingActivities.bind(
                            this,
                            item.classId ? item.classId : '0',
                            item.courseId ? item.courseId : '0'
                        )}
                        className={item.upcomingActivity && item.upcomingActivity > 0 ? 'notify-dot' : 'opacity-3'}
                    >
                        <img src={_common.GetDefaultIcons('clock')} alt="newActivityCount" />
                    </i>
                </Tooltip>
            </div>
        );
    };

    renderProgressCircle = (progress: any) => {
        return <div className="list-icons d-flex align-items-center">{<ProgressCircle percent={progress} />}</div>;
    };

    showMoreLesson = () => {
        this.setState({ moreLesson: !this.state.moreLesson });
    };

    public render() {
        let filteredCourses = this.activeCourses();
        let courseCount = 0;
        if (this.props.userHomeMyCourses!.length >= 9) {
            courseCount = 9;
        } else {
            courseCount = this.props.userHomeMyCourses!.length;
        }

        const { useHomeMyCoursesIsLoading } = this.props;
        return (
            <div className={filteredCourses && filteredCourses.length > 0 ? `col-md-8 col-12` : `col-12`}>
                <div className="col-12">{this.renderMyCoursesLoading()}</div>

                <div id="getUserHomeMyCourses_Content" className=" col-12">
                    {this.renderMyCoursesHeader(filteredCourses)}

                    <div
                        id="getUserHomeMyCourses_Content"
                        className={filteredCourses && filteredCourses.length > 0 ? `grid-3 gap-2` : `grid-1`}
                        style={{ marginTop: '15px' }}
                    >
                        {filteredCourses && filteredCourses.length > 0 ? (
                            filteredCourses?.slice(0, this.state.moreLesson ? this.props.userHomeMyCourses!.length : courseCount).map(
                                (item, index) =>
                                    item.activeStatus === 1 && (
                                        <div
                                            className="active_course_list_item_new"
                                            onClick={this.navigateUrl.bind(this, item.classId, item.courseId)}
                                            style={{ cursor: 'pointer' }}
                                            key={item.courseId}
                                        >
                                            {this.renderProgramNameContent(item)}
                                            <div className="d-flex align-items-center justify-content-between">
                                                <div className="d-flex align-items-center justify-content-start">
                                                    {item.teachers && item.teachers.length > 0
                                                        ? item.teachers
                                                              .split(',')
                                                              .slice(0, 4)
                                                              .map((teacher: string, index: number) => {
                                                                  const teacherName = teacher.trim();
                                                                  const parts = teacherName.split(' ').filter(p => p.length > 0);
                                                                  let initials = '';
                                                                  if (parts.length === 1) {
                                                                      initials = parts[0][0];
                                                                  } else {
                                                                      initials = parts[0][0] + parts[parts.length - 1][0];
                                                                  }
                                                                  initials = initials.toUpperCase(); // İsterseniz harfleri büyük yapabilirsiniz.

                                                                  return (
                                                                      <Tooltip key={index} data={teacher.trim()} delay={100} position="top">
                                                                          <Avatar
                                                                              initials={initials}
                                                                              name={teacher.trim()}
                                                                              backgroundColor={this.getColorFromName(teacher)}
                                                                              style={{ marginInlineStart: index === 0 ? '0' : '-8px' }}
                                                                          />
                                                                      </Tooltip>
                                                                  );
                                                              })
                                                        : null}

                                                    {item.teachers && item.teachers.split(',').length > 4 && (
                                                        <Tooltip
                                                            data={item.teachers
                                                                .split(',')
                                                                .slice(4)
                                                                .join(', ')}
                                                            delay={300}
                                                            position="top"
                                                        >
                                                            <div
                                                                className="avatar-badge-container"
                                                                style={{
                                                                    backgroundColor: '#6b47dc',
                                                                    width: 24,
                                                                    height: 24,
                                                                    marginInlineStart: '-8px'
                                                                }}
                                                            >
                                                                <span className="initials">+{item.teachers.split(',').length - 4}</span>
                                                            </div>
                                                        </Tooltip>
                                                    )}
                                                </div>
                                                <div
                                                    aria-hidden="true"
                                                    style={{ marginInlineEnd: '8px' }}
                                                    className="w-100 align-self-center d-flex justify-content-end gap-2 mobile-mt1"
                                                    onClick={this.navigateUrl.bind(this, item.classId, item.courseId)}
                                                >
                                                    {this.props.userType === UserType.Student ? (
                                                        ''
                                                    ) : (
                                                        <div className="list-icons ">
                                                            <Tooltip data={this.renderProgramNames(item.programName ?? '')} position="top">
                                                                <i>
                                                                    <img src={_common.GetDefaultIcons('program')} alt="program_names" />
                                                                </i>
                                                            </Tooltip>
                                                        </div>
                                                    )}
                                                    {this.props.userType === UserType.Student && this.renderNewActivityIcon(item)}
                                                    {this.getUpcomingActivitiesIcon(item)}

                                                    {/* <div className="list-icons ">
                                                    <Tooltip data={(item.isNotifications && item.isNotifications > 0) ? (T.t('r_gen_student_newActivity_info').replace('{0}', item.newActivityCount)) : ''} position='top'>
                                                        <i className={(item.isNotifications && item.isNotifications > 0) ? ' notify-dot' : 'opacity-3'} tabIndex={0}>
                                                            <img src={_common.GetDefaultIcons('headerinboxdark')} alt="newActivityCount" />
                                                        </i>
                                                    </Tooltip>
                                                </div> */}
                                                </div>
                                            </div>
                                        </div>
                                    )
                            )
                        ) : (
                            <>
                                <NotFound message={T.t('r_main_navigation_course_none_record_message')} />
                                <Link
                                    className="category-tag-square tag-green  "
                                    style={{ width: 'max-content', margin: 'auto' }}
                                    to={window.appSettings.DEFAULT_URL + '/u/mycourse'}
                                >
                                    {T.t('r_gen_show_all')}{' '}
                                </Link>
                            </>
                        )}
                        {filteredCourses && filteredCourses.length > 9 && (
                            <div onClick={this.showMoreLesson} className="show_more_btn">
                                <Tooltip
                                    data={this.state.moreLesson === false ? T.t('r_gen_show_more') : T.t('r_gen_show_less')}
                                    delay={100}
                                    widthValue="100%"
                                >
                                    <span className={this.state.moreLesson === false ? `more` : `less`}></span>
                                </Tooltip>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: IUserHomeMyCoursesProps): IUserHomeMyCoursesProps => {
    if (!state) {
        return ownProps;
    }
    const newProps: IUserHomeMyCoursesProps = Object.assign({}, ownProps, {
        userHomeMyCourses: state.userHomePage.userHomeMyCourses,
        useHomeMyCoursesIsLoading: state.userHomePage.useHomeMyCoursesIsLoading,
        userType: state.login.identitiy.userType,
        userUpcomingActivities: state.userHomePage.userUpcomingActivities,
        userPreferences: state.profile.userPreferences.preferences
    });
    return newProps;
};

const areStatesEqual = (next: IAppState, prev: IAppState) => {
    const ret =
        next.login.identitiy === prev.login.identitiy && next.userHomePage.userHomeMyCourses === prev.userHomePage.userHomeMyCourses;
    return ret;
};

const dispatchProps = (dispatch: Dispatch<IAction>) => {
    return {
        dispatch
    };
};

const CUserMyCourses = connect(mapStateToProps, dispatchProps, null, {
    areStatesEqual
})(UserMyCourses);

export default withRouter(CUserMyCourses);
